import { useCallback, useMemo } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router";

export function useDialog() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const dialogId = searchParams.get("dialog");

  const dialogParams = useMemo(() => {
    return Object.fromEntries(
      Array.from(searchParams.entries()).filter(([key]) => key !== "dialog")
    );
  }, [searchParams]);

  const openDialog = useCallback(
    (id: string, params?: Record<string, string>) => {
      const newParams = new URLSearchParams({ dialog: id, ...params });
      navigate(`${location.pathname}?${newParams.toString()}`);
    },
    [navigate, location.pathname]
  );

  const closeDialog = useCallback(() => {
    navigate(location.pathname);
  }, [navigate, location.pathname]);

  return {
    dialogId,
    dialogParams,
    isOpen: !!dialogId,
    openDialog,
    closeDialog,
  };
}
